import { LogLevel, Configuration, BrowserCacheLocation } from '@azure/msal-browser';
import { environment } from '../environments/environment';

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

export const b2cPolicies = {
    names: {
        signUpSignIn: "B2C_1_SUSI",
        editProfile: "B2C_1_PE",
        resetPassword: "B2C_1_PWR",
    },
    authorities: {
        signUpSignIn: {
            authority: `https://${environment.tenantName}.b2clogin.com/${environment.tenantName}.onmicrosoft.com/B2C_1_SUSI`,
        },
        editProfile: {
            authority: `https://${environment.tenantName}.b2clogin.com/${environment.tenantName}.onmicrosoft.com/B2C_1_PE`,
        },
        resetPassword: {
            authority: `https://${environment.tenantName}.b2clogin.com/${environment.tenantName}.onmicrosoft.com/B2C_1_PWR`,
        },
    },
    authorityDomain: `${environment.tenantName}.b2clogin.com`
};


export const msalConfig: Configuration = {
    auth: {
        clientId: environment.clientId,
        authority: b2cPolicies.authorities.signUpSignIn.authority,
        knownAuthorities: [b2cPolicies.authorityDomain],
        redirectUri: '/claims/repair-facility/dashboard',
    },
    cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage,
        storeAuthStateInCookie: isIE,
    },
    system: {
        loggerOptions: {
            loggerCallback: (logLevel, message, containsPii) => {
                console.log(message);
            },
            logLevel: LogLevel.Verbose,
            piiLoggingEnabled: false
        }
    }
}

export const protectedResources = {
    scopes: [`https://${environment.tenantName}.onmicrosoft.com/api/access_as_user`],
    userApi: {
        endpoint: `${environment.baseClaimSubmissionUrl}/user`,
        scopes: [`https://${environment.tenantName}.onmicrosoft.com/api/access_as_user`],
    },
    claimApi: {
        endpoint: `${environment.baseClaimSubmissionUrl}/claims/repair-facility`,
        scopes: [`https://${environment.tenantName}.onmicrosoft.com/api/access_as_user`],
    },
    referenceApi: {
        endpoint: `${environment.baseClaimSubmissionUrl}/reference/`,
        scopes: [`https://${environment.tenantName}.onmicrosoft.com/api/access_as_user`],
    },
}